import { BRANDBOOK } from "@/lib/brand/brandbook";
import type { ResearchIconName } from "@/lib/icons/research-icons";
import type { LandingTextValue } from "@/lib/landing/puck/styled-text";

export type LandingHeroSplitHighlight = {
  icon: ResearchIconName | string;
  title: LandingTextValue;
  text: LandingTextValue;
};

export type LandingHeroSplitDefaults = {
  sectionId: string;
  /** Фон светлой темы — у Hero белый. */
  backgroundColor: string;
  /** Фон тёмной темы. Пусто = BRANDBOOK.ink. */
  backgroundColorDark: string;
  title: LandingTextValue;
  subtitle: LandingTextValue;
  primaryLabel: LandingTextValue;
  primaryHref: string;
  secondaryLabel: LandingTextValue;
  secondaryHref: string;
  /** Картинка справа (светлая тема) — сотрудник загружает в S3. */
  imageUrl: string;
  /** Картинка справа (тёмная тема). Пусто = светлая. */
  imageUrlDark: string;
  imageAlt: string;
  showHighlights: boolean;
  highlights: LandingHeroSplitHighlight[];
};

export const DEFAULT_HERO_SPLIT_HIGHLIGHTS: LandingHeroSplitHighlight[] = [
  {
    icon: "fileText",
    title: "20+ страниц",
    text: "объем отчета",
  },
  {
    icon: "barChart",
    title: "Проверенные данные",
    text: "",
  },
  {
    icon: "layoutDashboard",
    title: "6 критериев",
    text: "скоринга",
  },
  {
    icon: "clock",
    title: "10-15 минут",
    text: "на отчет",
  },
];

export const DEFAULT_HERO_SPLIT: LandingHeroSplitDefaults = {
  sectionId: "hero",
  backgroundColor: BRANDBOOK.white,
  backgroundColorDark: BRANDBOOK.ink,
  title: "Исследование рынка и проверка бизнес-идеи за 5 минут",
  subtitle:
    "Достоверный отчет 20+ страниц, скоринг по 6 критериям, цифры по рынку РФ и ссылки на источники",
  primaryLabel: "Провести исследование",
  primaryHref: "/reports/create",
  secondaryLabel: "посмотреть пример отчета",
  secondaryHref: "#cases",
  imageUrl: "",
  imageUrlDark: "",
  imageAlt: "Пример отчёта Idealitika",
  showHighlights: true,
  highlights: [...DEFAULT_HERO_SPLIT_HIGHLIGHTS],
};
